// extracted by mini-css-extract-plugin
export default {"inputWrapper":"styles_inputWrapper__HHIY+"};